import { LayoutModule } from '@angular/cdk/layout';
import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import localeTr from '@angular/common/locales/tr';
import localeTh from '@angular/common/locales/th';
import localeRu from '@angular/common/locales/ru';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BillingHistoryComponent } from '@app/billing-history/billing-history.component';
import { InvoiceTableComponent } from '@app/invoice-table/invoice-table.component';
import { PpApiGatewayService } from '@app/pp-api-gateway.service';
import { SessionStorage } from '@app/types/session-storage.enum';
import { JwtHelperService, JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { environment } from '@env/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FileSaverModule } from 'ngx-filesaver';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InvoiceDownloadButtonComponent } from './invoice-download-button/invoice-download-button.component';
import { RatePlanComponent } from './rate-plan/rate-plan.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { WarningDialogComponent } from './warning-dialog/warning-dialog.component';
import { AccountListComponent } from './account-list/account-list.component';
import { AccountComponent } from './account/account.component';
import { AutoRenewModule } from './auto-renew/auto-renew.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material';

registerLocaleData(localeEs);
registerLocaleData(localePt);
registerLocaleData(localeTr);
registerLocaleData(localeTh);
registerLocaleData(localeRu);

export function JwtOptionsFactory() {
  function logout() {
    const parentUrl = sessionStorage.getItem(SessionStorage.ParentUrl);
    window.parent.location.href = `${environment.lp2LogoutUrl
      }?oe_sso_redirect_url=${parentUrl}`;
  }

  return {
    tokenGetter: () => {
      const re = /OESSOTOK=(.*?)(;|$)/;
      if (!re.test(window.document.cookie)) {
        logout();
        return null;
      }
      const token = re.exec(window.document.cookie)[1];
      const helper = new JwtHelperService();
      if (helper.isTokenExpired(token)) {
        logout();
        return null;
      }
      return token;
    },
    authScheme: '',
    whitelistedDomains: environment.authorizationWhitelist.split(','),
    throwNoTokenError: true,
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${environment.oeThirdPartyService}/v1/nls/`, '/messages');
}

@NgModule({
  declarations: [
    AppComponent,
    BillingHistoryComponent,
    InvoiceTableComponent,
    InvoiceDownloadButtonComponent,
    WarningDialogComponent,
    SubscriptionComponent,
    RatePlanComponent,
    AccountListComponent,
    AccountComponent,
  ],
  entryComponents: [WarningDialogComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FileSaverModule,
    HttpClientModule,
    LayoutModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    AutoRenewModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: JwtOptionsFactory,
      },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [PpApiGatewayService],
  bootstrap: [AppComponent],
})
export class AppModule { }
